import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import type { ControllerRenderProps } from "react-hook-form";

import type { ForkSchema } from "../schema";
import { DEFAULT_DOCKER_IMAGE } from "./defaults";

interface ScriptDockerLiteProps {
  field: ControllerRenderProps<ForkSchema, `scripts.${number}.docker`>;
}

const ScriptDockerLite: FC<ScriptDockerLiteProps> = props => {
  const { field } = props;
  return (
    <FormItem className="flex flex-row items-center">
      <FormLabel className="w-24">Docker Image</FormLabel>
      <FormControl>
        <Input
          placeholder={DEFAULT_DOCKER_IMAGE}
          {...field}
          value={field.value ?? ""}
          className="h-8 w-[300px]"
        />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};

export default ScriptDockerLite;
